export const colors = {
  primary: '#FFF',
  secondary: '#142246',
  accent: '#FF8200'
}

export default {
  colors
}